import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { getAllGrupos, unirGrupos } from "../../../services/grupo.service";
import { showAlertGrupo, showErrorAlert } from "../../../components/molecules/ShowAlert";
import { FormDiv } from "../../../components/atoms/FormDiv";
import { LoadingButton } from "../../../components/atoms/LoadingButton";
import { SelectGrupo } from "../../../components/atoms/SelectGrupo";

export const UnirGruposPage = () => {
  const [grupos, setGrupos] = useState([]);
  const [grupo1, setGrupo1] = useState(null);
  const [grupo2, setGrupo2] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const response = await getAllGrupos();
        setGrupos(response);
      } catch (error) {
        showErrorAlert({ text: "Error al obtener los grupos. Por favor, inténtelo de nuevo." });
      }
    })();
  }, []);

  const handleUnirGrupos = async () => {
    if (!grupo1 || !grupo2) {
      showErrorAlert({ text: "Debe seleccionar dos grupos válidos para unir." });
      return;
    }
    setLoading(true);
    try {
      const payload = { grupo1Id: grupo1.idGrupo, grupo2Id: grupo2.idGrupo };
      await unirGrupos(payload);
      showAlertGrupo({ text: "Grupos unidos correctamente", callback: () => navigate("/grupos") });
    } catch (error) {
      console.error("Error en handleUnirGrupos:", error);
      showErrorAlert({ text: "No se pudo realizar la unión de grupos. Intente nuevamente." });
    } finally {
      setLoading(false);
    }
  };
  return (
    <ContenedorPageTemplate titulo="Unir Grupos">
      <FormDiv className="space-y-4">
        <SelectGrupo
          titulo="Seleccione el primer grupo:"
          grupos={grupos}
          grupoSeleccionado={grupo1}
          setGrupoSeleccionado={setGrupo1}
          placeholder="Escriba el nombre del grupo"
          filtrarGrupos={() => true}
        />

        <SelectGrupo
          titulo="Seleccione el segundo grupo:"
          grupos={grupos}
          grupoSeleccionado={grupo2}
          setGrupoSeleccionado={setGrupo2}
          placeholder="Seleccione un grupo del mismo módulo e idioma"
          disabled={!grupo1}
          filtrarGrupos={(g) =>
            grupo1
              ? g.idModulo === grupo1.idModulo &&
                g.idIdioma === grupo1.idIdioma &&
                g.idGrupo !== grupo1.idGrupo
              : false
          }
        />

        <LoadingButton
          isFormSubmit={false}
          onClick={handleUnirGrupos}
          text={loading ? "Uniendo..." : "Unir Grupos"}
          estaCargando={loading}
        />
      </FormDiv>
    </ContenedorPageTemplate>
  );
};
